/**
 * A document's name as a person reads it (D-82, W3-17 (4a)).
 *
 * A workbook kept sheet by sheet is one upload and several documents, each the same file read at
 * one sheet — eight rows of one file name would say nothing about which is which. A sheet's
 * document is named `file · sheet`; a whole file by its name alone, as before.
 */

export function documentName(
  doc: { source_filename?: string | null; sheet_name?: string | null },
  fallback = 'this file',
): string {
  const file = doc.source_filename ?? fallback
  return doc.sheet_name ? `${file} \u00b7 ${doc.sheet_name}` : file
}
